/**
 * Shared mention rendering utility.
 * Parses @[Name](id) patterns into styled spans.
 * Used by both the DigiBox vault and the main CRM messaging system.
 */

import React from "react";

/**
 * Render text containing @[Name](id) mention patterns as styled inline spans.
 * Accepts optional style overrides for vault vs CRM contexts.
 */
export function renderMentions(
  text: string,
  style?: {
    color?: string;
    background?: string;
  }
): React.ReactNode {
  const parts = text.split(/(@\[[^\]]+\]\([^)]+\))/g);
  return parts.map((part, i) => {
    const match = part.match(/^@\[([^\]]+)\]\(([^)]+)\)$/);
    if (match) {
      return (
        <span
          key={i}
          style={{
            color: style?.color ?? "#6366f1",
            fontWeight: 500,
            background: style?.background ?? "rgba(99, 102, 241, 0.08)",
            padding: "1px 4px",
            borderRadius: 2,
          }}
        >
          @{match[1]}
        </span>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

/** Vault-themed mention renderer (uses CSS variables) */
export function renderMentionsVault(text: string): React.ReactNode {
  return renderMentions(text, {
    color: "var(--vault-accent)",
    background: "var(--vault-zone-comment-bg)",
  });
}
